import moment from 'moment';
import { useParams } from 'react-router-dom';
import { Box } from '@chakra-ui/react';

import { Condition } from 'Component/others';
import Breadcrumb from 'UiKit/breadcrumb';
import { TextBold } from 'UiKit/typography';

import { HeadSkeleton } from 'View/report-attendance-operator/component/skeleton';
import { useReportAttendanceOperatorState } from 'View/report-attendance-operator/state';
import { reportAttendanceOperatorText } from 'View/report-attendance-operator/const';
import { getBreadcrumbItem } from 'View/report-attendance-operator/helper/getBreadcrumbItems';

import styles from './styles.module.css';

const Head = ({ data, isLoading }) => {
  const { filterState } = useReportAttendanceOperatorState();
  const params = useParams();
  const { id } = params;
  const isOperator = !Boolean(id);

  const reportDetail = { operatorName: data?.operatorName, periode: filterState?.monthYear && moment(filterState.monthYear).format('MMMM YYYY') };

  const breadcrumbItems = getBreadcrumbItem(isOperator, reportDetail);

  return (
    <Box className={styles['head__container']}>
      <Condition fallback={<HeadSkeleton />} statement={!isLoading}>
        <Breadcrumb items={breadcrumbItems} isLoading={isLoading} />
        <Condition statement={isOperator} fallback={<TextBold className={styles['head__title']}>{reportDetail?.operatorName}</TextBold>}>
          <TextBold className={styles['head__title']}>{reportAttendanceOperatorText.titleText}</TextBold>
        </Condition>
      </Condition>
    </Box>
  );
};

export default Head;
